import { Plugin } from 'vue';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import { getEnv } from '@/shared/utils/get-env.ts';

export const SentryPlugin = {
  install: async (app) => {
    Sentry.init(
      {
        app,
        enabled: import.meta.env.PROD,
        dsn: getEnv('VITE_SENTRY_DSN'),
        // Adds request headers and IP for users, for more info visit:
        // https://docs.sentry.io/platforms/javascript/guides/capacitor/configuration/options/#sendDefaultPii
        sendDefaultPii: true,
        // Set your release version, such as "getsentry@1.0.0"
        integrations: [
          // Sentry.browserTracingIntegration(),
          // SentryVue.replayIntegration({
          //   maskAllText: false,
          //   blockAllMedia: false,
          // }),
        ],
        // replaysSessionSampleRate: 1.0,
        // replaysOnErrorSampleRate: 1.0,
      },
      // Forward the init method from @sentry/vue
      SentryVue.init,
    );

    if (Capacitor.isNativePlatform()) {
      Sentry.setContext('Device', {
        ...(await Device.getInfo()),
      });
    }
  },
} as Plugin;
